export default __webpack_public_path__ + "static/media/banner1.21855a07.jpg";